import * as Yup from "yup";
import { Helmet } from "react-helmet-async";
// @mui
import { LoadingButton } from "@mui/lab";
import { Container, Grid, Card, Stack, Typography } from "@mui/material";
// components
import { useSettingsContext } from "../components/settings";
import { useSnackbar } from "../components/snackbar";
import FormProvider, { RHFTextField } from "../components/hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { addToActivationDebugGroup } from "../controllers/user";

// ----------------------------------------------------------------------

export default function AddToActivationDebug() {
    const { themeStretch } = useSettingsContext();
    const { enqueueSnackbar } = useSnackbar();

    const defaultValues = {
        userId: "",
    };

    const schema = Yup.object().shape({
        userId: Yup.string().required("User ID is required"),
    });

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting, isValid },
    } = methods;

    const onSubmit = async (data: { userId: string }) => {
        addToActivationDebugGroup(data.userId)
            .then(() => {
                reset();
                enqueueSnackbar(
                    `Successfully added user to activation debug group: ${data.userId}`
                );
            })
            .catch((error) => {
                console.error(error);
                enqueueSnackbar(
                    `Could not add user to activation debug group: ${data.userId}`,
                    {
                        variant: "error",
                    }
                );
            });
    };

    return (
        <>
            <Helmet>
                <title> Clone a User | Admin Portal</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : "xl"}>
                <Typography variant="h3" component="h1" paragraph>
                    Add a User to Activation Debug
                </Typography>

                <FormProvider
                    methods={methods}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8}>
                            <Card sx={{ p: 3 }}>
                                <Stack spacing={3}>
                                    <RHFTextField
                                        name="userId"
                                        label="User ID"
                                        required
                                    />
                                </Stack>
                            </Card>
                            <Stack direction="row" spacing={1.5} sx={{ mt: 3 }}>
                                <LoadingButton
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    loading={isSubmitting}
                                    disabled={!isValid}
                                >
                                    Add To Activation Debug
                                </LoadingButton>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Container>
        </>
    );
}
